var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dashboard-designer cdsp_dashboard",
      style: _vm.dashboardStyle,
    },
    [
      _c(
        "div",
        { ref: "previewContainer", staticClass: "canvas-panel-container" },
        [
          _c("canvas-panel", {
            ref: "grid",
            attrs: {
              dashboardName: _vm.layoutObj.dashboardName,
              chartDirection: _vm.chartDirection,
              chartPreviewMode: _vm.chartPreviewMode,
              previewMode: _vm.previewMode,
              gridLayout: _vm.layoutObj.layout,
              previewFlag: _vm.getPreviewFlag,
              chartConfigHandler: _vm.chartConfigHandler,
            },
            on: {
              "sort-change": _vm.handleSortChange,
              "drill-item-click": _vm.handleDrillItemClick,
              "handle-table-command": _vm.handleTableCommand,
              "table-page-change": _vm.handleTablePageChange,
              "update:gridLayout": function ($event) {
                return _vm.$set(_vm.layoutObj, "layout", $event)
              },
              "update:grid-layout": function ($event) {
                return _vm.$set(_vm.layoutObj, "layout", $event)
              },
              chartSelect: _vm.handleChartSelect,
              "grid-resize": _vm.handleGridResize,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }